import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/** Центы → «12,34 €» в формате языка интерфейса. */
export function formatMoney(
  minor: number | null | undefined,
  currency = 'EUR',
  locale = 'ru',
): string {
  if (minor === null || minor === undefined) return '—';
  return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(minor / 100);
}

/** «12,34» → 1234 центов; пустое/неверное значение → undefined. */
export function parseMoney(value: string): number | undefined {
  const normalized = value.replace(/\s/g, '').replace(',', '.');
  if (!/^\d+(\.\d{1,2})?$/.test(normalized)) return undefined;
  return Math.round(Number(normalized) * 100);
}

export function formatDateTime(value: string | null | undefined, locale = 'ru'): string {
  if (!value) return '—';
  return new Intl.DateTimeFormat(locale, { dateStyle: 'short', timeStyle: 'short' }).format(
    new Date(value),
  );
}

/** Пустые строки формы → undefined (API не принимает '' вместо «не задано»). */
export function emptyToUndefined<T extends Record<string, unknown>>(values: T): Partial<T> {
  const result: Partial<T> = {};
  for (const [key, value] of Object.entries(values) as [keyof T, T[keyof T]][]) {
    if (value !== '' && value !== undefined) result[key] = value;
  }
  return result;
}
